import React from "react"

import { LANGUAGE } from "actions/constants"

export default {
    [LANGUAGE.EN]: {
        Title: () => <span> Lin and Brian are celebrating their wedding!</span>,
        Date: () => (
            <div className="d-flex flex-column">
                <div>
                    <span>
                       10/28/2025
                    </span>
                </div>
            </div>
        ),
        Location: () => <span>Kaomai Lanna Resort, Chiang Mai, Thailand</span>,
        locationLink: "https://maps.app.goo.gl/9MHyt8CSNGa1ozVe9",
    },
    [LANGUAGE.ZH]: {
        Title: () => <span>毛琳和布莱恩的婚礼要来啦！</span>,
        Date: () => (
            <div className="d-flex flex-column">
                <div>
                    <span>
                       2025年10月28日 
                    </span>
                </div>
            </div>
        ),
        Location: () => <span>清迈高迈兰纳度假酒店</span>,
        locationLink: "https://surl.amap.com/16ymesVx13W",
    },
}
